import { largeNumberDisplay } from '@/utils/helpers';

function setLargeNumber(el, binding) {
  el.innerHTML = largeNumberDisplay(binding.value || 0);
}

export default {
  mounted(el, binding) {
    setLargeNumber(el, binding);
  },
  updated(el, binding) {
    setLargeNumber(el, binding);
  },
};
